import { writable } from 'svelte/store';

let siteText            = 'Dinmar Administradora de Imóveis';
let siteDescription     = 'Referência em administração de condomínios, aluguel, compra e venda de imóveis em Porto Alegre - RS';

export let tagsSEO      = writable('Referência em administração de condomínios, aluguel, compra e venda de imóveis em Porto Alegre-RS.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

// E-mails
export const mailAtendimento	= writable("siteatendimento@dinmar.com.br");
export const mailLocacao		= writable("sitelocacoes@dinmar.com.br");
export const mailVendas			= writable("sitevendas@dinmar.com.br");
export const mailCondominios	= writable("sitecondominio@dinmar.com.br");
export const mailOuvidoria		= writable("siteouvidoria@dinmar.com.br");
export const mailRH				= writable("siterh@dinmar.com.br");
export const mailLista			= writable("sitelista@dinmar.com.br");
export const mailAtualize		= writable("siteatendimento@dinmar.com.br");

export const textTelefone		= writable("(51) 3211-2622");
export const linkTelefone		= writable("tel://5132112622");

export const whatsapp			= writable("5551991928012");
export const textWhatsapp		= writable("(51) 99192-8012");
export const linkWhatsapp		= writable("https://wa.me/5551991928012");

export const whatsappCondominio			= writable("5551981210756");
export const textWhatsappCondominio		= writable("(51) 98121-0756");
export const linkWhatsappCondominio		= writable("https://wa.me/5551981210756");

export const whatsappLocacao			= writable("5551981250047");
export const textWhatsappLocacao		= writable("(51) 98125-0047");
export const linkWhatsappLocacao		= writable("https://wa.me/5551981250047");

export const whatsappVendas				= writable("5551981019188");
export const textWhatsappVendas			= writable("(51) 98101-9188");
export const linkWhatsappVendas			= writable("https://wa.me/5551981019188");

export const whatsappRH					= writable("5551991567232");
export const textWhatsappRH				= writable("(51) 99156-7232");
export const linkWhatsappRH				= writable("https://wa.me/5551991567232");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#nt=2&tipo_negociacao=2&cidade=Porto%20Alegre");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#nt=1&tipo_negociacao=1&cidade=Porto%20Alegre");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("");
export const linkInstagram      = writable("");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");

export const linkMapa           = writable("https://goo.gl/maps/qP7UsrsMcJoEh7bn6");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJfxknpQh5GZURX4n7AK4t19Y&ll=-30.02990900%2C-51.22589100&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=Dinmar%20Administradora%20de%20Im%C3%B3veis%20-%20Rua%20Vig%C3%A1rio%20Jos%C3%A9%20In%C3%A1cio%20-%20Centro%20Hist%C3%B3rico%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.029909&dropoff[longitude]=-51.225891");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.2423500775253!2d-51.228079684479475!3d-30.02990433756193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95197908a527197f%3A0xd6d72dae00fb895f!2sDinmar%20Administradora%20de%20Im%C3%B3veis!5e0!3m2!1spt-BR!2sbr!4v1628168991791!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("https://www.api.com.br");
export const linkAV             = writable("https://appdinmar.com.br/dinmar/login");
export const linkAVConheca      = writable("https://appdinmar.com.br/conheca/");

export const textAtendimento            = writable("De segunda à sexta, das 9h às 12h, e das 13h às 17h.");
export const textEndereco               = writable("Rua Vigário José Inácio, 481/4° Andar <br> Centro Histórico, Porto Alegre - RS <br> CEP 90020-100");
export const textCNPJ                   = writable("89.452.718/0001-22");
export const textCreci                  = writable("20.286-J");